var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHosdashtesting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 470,
    viewBox: "0 0 470 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194 28C201.732 28 208 21.732 208 14C208 6.26801 201.732 0 194 0C186.268 0 180 6.26801 180 14C180 21.732 186.268 28 194 28Z",
    fill: "var(--color-primary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169 51C174.523 51 179 46.5229 179 41C179 35.4772 174.523 31 169 31C163.477 31 159 35.4772 159 41C159 46.5229 163.477 51 169 51Z",
    fill: "url(#paint0_linear_1_23094)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161 433C166.523 433 171 428.523 171 423C171 417.477 166.523 413 161 413C155.477 413 151 417.477 151 423C151 428.523 155.477 433 161 433Z",
    fill: "var(--color-ternary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M319.507 382.232H0V62.7451H319.507V382.232Z",
    fill: "#242424"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M319.507 382.232H0V62.7451H319.507V382.232ZM4.72068 377.511H314.786V67.4655H4.72068V377.511Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 200.089H65.877V207.322H270.787V200.089Z",
    fill: "var(--color-primary)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 218.894H65.877V226.127H270.787V218.894Z",
    fill: "url(#paint1_linear_1_23094)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 237.701H65.877V244.934H270.787V237.701Z",
    fill: "var(--color-primary)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4394 209.486C56.0466 209.486 58.1601 207.373 58.1601 204.766C58.1601 202.158 56.0466 200.045 53.4394 200.045C50.8323 200.045 48.7188 202.158 48.7188 204.766C48.7188 207.373 50.8323 209.486 53.4394 209.486Z",
    fill: "#F1F1F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 119.055H65.877V126.289H270.787V119.055Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 137.861H65.877V145.094H270.787V137.861Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 156.667H65.877V163.9H270.787V156.667Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4394 127.666C56.0466 127.666 58.1601 125.553 58.1601 122.946C58.1601 120.339 56.0466 118.225 53.4394 118.225C50.8323 118.225 48.7188 120.339 48.7188 122.946C48.7188 125.553 50.8323 127.666 53.4394 127.666Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 281.908H65.877V289.141H270.787V281.908Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 300.714H65.877V307.947H270.787V300.714Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 319.521H65.877V326.754H270.787V319.521Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4394 290.519C56.0466 290.519 58.1601 288.405 58.1601 285.798C58.1601 283.191 56.0466 281.078 53.4394 281.078C50.8323 281.078 48.7188 283.191 48.7188 285.798C48.7188 288.405 50.8323 290.519 53.4394 290.519Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M455.205 470V388C455.205 388 486.705 446.135 455.205 470Z",
    fill: "var(--color-ternary)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M459.019 470L397.205 414C397.205 414 463.144 429.929 459.019 470Z",
    fill: "var(--color-primary)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M366.562 456.09H355.295L354.65 412.705L366.562 412.021V456.09Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M368.942 468.001L332.018 468V467.502C332.022 463.529 333.538 459.72 336.233 456.91C338.928 454.101 342.581 452.521 346.392 452.516H368.942V468.001Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M428.801 444.271L417.824 448.867L399.023 409.096L410.344 403.607L428.801 444.271Z",
    fill: "#EBEBEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M401.623 467.923L401.429 467.482C400.664 465.739 400.253 463.863 400.217 461.961C400.182 460.059 400.524 458.169 401.224 456.399C401.924 454.629 402.968 453.013 404.297 451.643C405.625 450.274 407.212 449.178 408.967 448.418L429.929 439.338L435.948 453.056L401.623 467.923Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M386.808 155.17C400.623 155.17 411.822 143.972 411.822 130.158C411.822 116.345 400.623 105.146 386.808 105.146C372.994 105.146 361.795 116.345 361.795 130.158C361.795 143.972 372.994 155.17 386.808 155.17Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M425.38 427.628L399.578 357.138L412.123 293.625L382.183 292L368.941 364.336L403.795 437.844L425.38 427.628Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M396.336 278.897L380.922 362.979L376.287 442.759L349.678 442.527L348.691 290.496L396.336 278.897Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M417.777 283.79L416.275 298.048L341.545 301.526L346.605 280.087L417.777 283.79Z",
    fill: "var(--color-ternary)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M345.853 331.705C345.122 330.798 344.582 329.757 344.262 328.643C343.943 327.529 343.851 326.363 343.992 325.214C344.133 324.064 344.504 322.954 345.083 321.946C345.663 320.939 346.439 320.055 347.368 319.346C347.757 319.049 348.17 318.783 348.602 318.552L378.572 207.576L396.337 215.269L361.13 322.511C361.969 324.308 362.167 326.331 361.691 328.253C361.216 330.174 360.095 331.881 358.511 333.096C356.64 334.552 354.261 335.223 351.892 334.962C349.522 334.702 347.352 333.531 345.853 331.705Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M365.322 179.414L368.79 172.249C368.79 172.249 385.869 157.484 403.882 166.335L406.659 174.606L421.35 198.333L418.031 286.343C418.031 286.343 356.737 281.682 341.545 287.236L348.223 221.976L365.322 179.414Z",
    fill: "var(--color-primary)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M368.569 318.344L342.738 311.14L366.627 236.704L368.789 195.145C368.914 193.046 369.48 190.996 370.449 189.129C371.418 187.261 372.77 185.617 374.417 184.303C376.401 182.7 378.695 181.523 381.157 180.847C383.619 180.17 386.194 180.008 388.722 180.371C397.163 181.524 403.371 187.959 403.485 195.673L403.485 195.71L403.48 195.748L395.184 253.999L392.524 263.481L368.569 318.344Z",
    fill: "#EBEBEB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M398.705 150.138L404.392 151.597L413.012 142.297C413.012 142.297 428.853 105.006 393.841 99.2991C358.83 93.5925 366.476 107.999 361.795 117.034L376.101 120.809L388.977 134.167C388.977 134.167 397.379 127.921 399.85 133.586C402.321 139.251 398.705 150.138 398.705 150.138Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M469.13 470H230.528C230.297 470 230.076 469.887 229.913 469.687C229.75 469.487 229.658 469.215 229.658 468.931C229.658 468.648 229.75 468.376 229.913 468.176C230.076 467.976 230.297 467.863 230.528 467.863H469.13C469.36 467.863 469.581 467.976 469.744 468.176C469.908 468.376 469.999 468.648 469.999 468.931C469.999 469.215 469.908 469.487 469.744 469.687C469.581 469.887 469.36 470 469.13 470Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_23094",
    x1: 161,
    y1: 46.9524,
    x2: 178.135,
    y2: 36.9424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_23094",
    x1: 86.3679,
    y1: 224.663,
    x2: 87.2246,
    y2: 210.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosdashtesting);
export default __webpack_public_path__ + "static/media/HOSDASHTESTING.a407b2c1afa24cdf88b6a5d048088089.svg";
export { ForwardRef as ReactComponent };